import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./primitives";
import { Magnetic } from "./Magnetic";
import { WaitlistModal } from "./WaitlistModal";

export const CTABand = () => {
  const [open, setOpen] = useState(false);
  return (
    <section id="early-access" data-testid="cta-band" className="relative border-t border-white/10 bg-[#0A0A0A] overflow-hidden">
      <div className="absolute left-1/2 -translate-x-1/2 top-0 h-64 w-[600px] lime-glow" />
      <div className="relative mx-auto max-w-[1000px] px-6 md:px-12 py-24 md:py-32 text-center">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#B4BAC4]">// Founder Terminal · early access</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-display font-semibold tracking-[-0.03em] text-[2rem] sm:text-5xl lg:text-6xl leading-[0.98]">
            Quantify the market.<br /><span className="text-[#7D8390]">Capture the edge.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-lg mx-auto text-sm text-white/55 leading-relaxed">
            The public terminal is free today. Sign up now to lock founder pricing on the full
            TradrQuant terminal before it launches.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <Magnetic className="mt-10 inline-block" strength={0.4}>
            <button
              type="button"
              onClick={() => setOpen(true)}
              data-testid="cta-waitlist-button"
              className="group inline-flex items-center gap-2 bg-[#BACD1C] text-black font-mono text-sm uppercase tracking-[0.15em] px-8 py-4 hover:bg-white active:scale-[0.98] transition-[background-color,transform] duration-300"
            >
              Create free account
              <ArrowRight size={16} className="group-hover:translate-x-0.5 transition-transform duration-300" />
            </button>
          </Magnetic>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-4 font-mono text-[11px] text-white/30 tracking-[0.15em] uppercase">No card · one email when access opens</p>
        </Reveal>
      </div>
      <AnimatePresence>
        {open && <WaitlistModal open={open} onClose={() => setOpen(false)} />}
      </AnimatePresence>
    </section>
  );
};
